import { SERVICING_VARIANT_MAPPING } from "./constant";

export const getIsNewServicingVariant = (experimentName) => {
    const newServicingExperiment = experimentName === SERVICING_VARIANT_MAPPING.VARIANT;
    return newServicingExperiment;
};
